
















import { Component, Watch, Vue } from 'vue-property-decorator'
import _ from 'lodash'

@Component

export default class ViewUpdate extends Vue {
  salario: Number = 1000.50

  calculate() {
    this.changeSalario()
  }

  changeSalario() {
    _.debounce((e) => {}, 1000)
  }
}
